import {capitalizeFirstLetter, endpoints} from "../../../utils2";
import {useParams} from "react-router-dom";
import {useAuth} from "../../../context";
import {useGetJson} from "../../../hooks";
import {Alert} from "react-bootstrap";

export function RenderDailyShort({config1}) {
    const shortDays = config1.daily.map(item =>
        capitalizeFirstLetter(item).slice(0, 3)
    )
    return <div>{shortDays.join(", ")}</div>
}

export function RenderControlledBy({config1}) {
    const {uid} = useParams()
    const {authToken} = useAuth()

    const [dev, loadingDevice, errorDevice, clearErrorDevice] = useGetJson(endpoints.device.get(uid, config1?.controlled_by_id), authToken?.jwt)
    const deviceName = dev?.data.name

    return <>
        <Alert variant="danger" show={errorDevice} dismissible onClose={clearErrorDevice}>{errorDevice}</Alert>

        <div className="fw-light">{deviceName}</div>
    </>
}
